// extracted by mini-css-extract-plugin
export var content = "_nj-1";
export var noScroll = "_nj-3";
export var paper = "_nj-0";
export var scrollable = "_nj-2";